module.exports = __webpack_public_path__ + "img/need_login.f347a008.png";